module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/CO-c97a7cb982846d29c8b7a4e7249ce473.png";